<template>
  <div>
    <Card>
      <div slot="title">挂网信息</div>
      <Form ref="operatorInfo" :model="operatorInfo" inline :label-width="100" :rules="operateValidate">
        <FormItem label="挂网人员" prop="operator">
          <Input type="text" v-model="operatorInfo.operator"></Input>
        </FormItem>
        <FormItem label="挂网日期" prop="inviteDate" required>
          <DatePicker type="datetime" v-model="operatorInfo.inviteDate" format="yyyy-MM-dd HH:mm" placeholder="挂网日期" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="报名费（元）" prop="enrollFee">
          <Input type="text" v-model="operatorInfo.enrollFee"></Input>
        </FormItem>
        <FormItem label="报名截止日期" prop="enrollEndDate" required>
          <DatePicker type="datetime" v-model="operatorInfo.enrollEndDate" format="yyyy-MM-dd HH:mm" placeholder="报名截止日期" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="挂网" prop="spreadWeb">
          <Select v-model="operatorInfo.spreadWeb" multiple style="width:300px;position:relative;z-index:20">
            <Option v-for="item in spreadTypeArr" :value="item.itemCode" :key="item.itemCode">{{ item.itemName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否网上报名" prop="isWebEnroll">
          <Select v-model="operatorInfo.isWebEnroll" style="width:100px;">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="是否按包组收费" :label-width="120" prop="isGroupPrice">
          <Select v-model="operatorInfo.isGroupPrice" style="width:100px;">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="跟进人员">
          <Input v-model="operatorInfo.merchandiser"></Input>
        </FormItem>
        <FormItem label="代理机构联系人" :label-width="120" prop="agencyContactPerson">
          <Input v-model="operatorInfo.agencyContactPerson" style="width:220px"></Input>
        </FormItem>
        <FormItem label="联系电话" prop="agencyContactNumber">
          <Input v-model="operatorInfo.agencyContactNumber" placeholder="供应商可通过此电话联系项目负责人" style="width:220px"></Input>
        </FormItem>
        <FormItem label="采购文件电子版">
          <Input v-model="operatorInfo.bidFile.displayName" readonly style="width:300px;"></Input>
        </FormItem>
        <FormItem :label-width="1">
          <Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
            <Button type="primary" size="small" :disabled="isFileExist">上传</Button>
          </Upload>
        </FormItem>
        <FormItem :label-width="1">
          <Button style="margin-right: 10px;" type="primary" size="small" @click="downloadFile" :disabled="!isFileExist">下载</Button>
          <Button type="error" size="small" @click="delectFile" :disabled="!isFileExist">删除</Button>
        </FormItem>
        <FormItem :label-width="1">
          <span>（供应商报名成功后可直接选择此文件发送到供应商报名填写邮箱）</span>
        </FormItem>
      </Form>
      <div style="width:100%;text-align:center;">
        <Button type="primary" @click="submitOperateInfo">确定</Button>
      </div>
    </Card>
    <Card style="margin-top: 10px;">
      <div slot="extra">
        <Button type="primary" size="small" @click="addInviteArticle">新增公告</Button>
      </div>
      <div slot="title">{{isSurveyProject?'调研':'招标'}}公告挂网</div>
      <Table :columns="inviteArticlesColumns" :data="articles"></Table>
    </Card>
    <Modal class="invite-modal" v-model="articleEditorVisible" width="1000px" :mask-closable="false">
      <div slot="header">公告编辑</div>
      <articleEditor
        ref="articleEditor"
        :selectArticle="selectArticle"
        editorId="e-invite"
        @cancel="articleEditorVisible=false"
        :projectData="projectData"
        :articleInfo="operatorInfo"
        @addSuccess="articleAddSuccess"
        v-if="!isSurveyProject"
      ></articleEditor>
      <articleEditor
        ref="articleEditor"
        :selectArticle="selectArticle"
        editorId="e-survey"
        @cancel="articleEditorVisible=false"
        :projectData="projectData"
        :articleInfo="operatorInfo"
        @addSuccess="articleAddSuccess"
        v-else
      ></articleEditor>
      <div slot="footer">
        <!-- <Button @click="articleEditorVisible=false">取消</Button>
        <Button type="primary">确定</Button> -->
      </div>
    </Modal>
    <Modal class="invite-modal" v-model="showCode" :mask-closable="false" :width="300" style="text-align:center">
      <div slot="header">扫码查看公告详情</div>
      <img :src="'data:image/png;base64,' + qrBase" style="width:200px">
      <p>官网公告详情链接：
        <a :href="'http://www.chinapsp.cn/wxNotice.html?itemid='+articleId" target="blank">
          http://www.chinapsp.cn/wxNotice.html?itemid={{articleId}}
        </a>
      </p>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import articleEditor from './articleEditor'
import ajax from '@/lib/ajax'
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import util from '@/lib/util'
import { formatDate, isWeiXin } from '@/lib/tool'
import { fileUtil } from '@/lib/abpfile'
import localFile from '@/lib/localFile'

export default {
  props: {
    projectData: {
      type: Object
    },
    articles: {
      type: Array
    }
  },
  data() {
    return {
      inviteArticlesColumns: [
        {
          title: '公告名称',
          key: 'title'
        },
        {
          title: '公告时间',
          width: 180,
          render: (h, params) => {
            let time = ''
            if (params.row.creationTime) {
              time = params.row.creationTime.replace('T', ' ').split('.')[0]
            }
            return h('span', time)
          }
        },
        {
          title: '操作',
          width: 300,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.articleId = params.row.id
                    ajax.post('https://api.choicelink.cn/UserCenter/api/TokenAuth/QRCode', {
                      "path": `pages/articlePage/articlePage?itemid=${params.row.id}`,
                      "authProvider": "cailian"
                    }).then(res => {
                      this.showCode = true
                      this.qrBase = res.data.result
                    })
                  }
                }
              }, '二维码/详情链接'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // 挂网权限
                    if (!this.netButton) {
                      this.$Message.error('无挂网权限')
                      return
                    }
                    this.viewArticle(params.row)
                  }
                }
              }, '查看/编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (!this.netButton) {
                      this.$Message.error('无挂网权限')
                      return
                    }
                    this.deleteArticle(params.row)
                  }
                }
              }, '删除')
            ])
          }
        },
      ],
      operatorInfo: {
        operator: '',
        inviteDate: '',
        enrollFee: '',
        enrollEndDate: '',
        spreadWeb: ['采联国际'],
        isWebEnroll: '',
        merchandiser: '',
        bidFile: '',
        isGroupPrice: '',
        agencyContactNumber: '',
        agencyContactPerson: ''
      },
      articleEditorVisible: false,
      operateValidate: {
        operator: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // inviteDate: [
        //   { required: true, type: 'date', message: '不能为空', trigger: 'change' }
        // ],
        enrollFee: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // enrollEndDate: [
        //   { required: true, type: 'date', message: '不能为空', trigger: 'change' }
        // ],
        spreadWeb: [
          { required: true, type: 'array', message: '不能为空', trigger: 'change' }
        ],
        isWebEnroll: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        isGroupPrice: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        agencyContactNumber: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        agencyContactPerson: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      },
      hasSubmit: false,
      selectArticle: {
        id: '',
        articleContentId: '',
        title: '',
        articleContent: ''
      },
      uploadFileInit: {
        action: '',
        extradata: {}
      },
      bucket: 'chinapsp-resource',
      dir: 'cgFile/',
      spreadTypeArr: [],
      qrBase: '',
      showCode: false,
      articleId: ''
    }
  },
  components: {
    articleEditor
  },
  computed: {
    user() {
      return this.$store.state.session.user
		},
    netButton() {
      if (this.$store.state.session.roleNames.indexOf('挂网人员') !== -1) {
        return true
      }
      return false
    },
    isFileExist() {
      return this.operatorInfo.bidFile.displayName ? true : false
    },
    isSurveyProject () {
      return this.projectData.businessType === '采购咨询' && this.projectData.projectProperty === '市场调研'
    }
  },
  mounted () {
    this.getDataDict('挂网地址').then(res => {
      this.spreadTypeArr = res
    })
  },
  methods: {
    deleteArticle(row) {
      this.$Modal.confirm({
        title: '公告删除',
        content: `确认删除公告${row.title}`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.delete(requestUrls.articles.Delete, {
              params: {
                id: row.id
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('删除成功')
              this.$emit('refreshArticles')
            } else {
              this.$Message.error('删除失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('删除失败')
            console.error(err)
          }
        }
      })
    },
    // visibleChange(val) {
    //   if (!val) {
    //     this.$refs.articleEditor.refreshInfo()
    //   }
    // },
    async viewArticle(row) {
      this.$Spin.show()
      try {
        // 获取公告内容
        let rep = await ajax.get(requestUrls.articlesData.GetArticleDataByAIdAsync, {
          params: {
            aId: row.id
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.selectArticle = row
          this.selectArticle.articleContent = rep.data.result.content
          this.selectArticle.articleContentId = rep.data.result.id
          this.articleEditorVisible = true
        } else {
          this.$Message.error('获取公告信息失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('获取公告信息失败')
      }
    },
    async addInviteArticle() {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '公告功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      // 挂网权限
      if (!this.netButton) {
        this.$Message.error('无挂网权限')
        return
      }
      // 查询包组是否建立
      this.$Spin.show()
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: `projectId=="${this.projectData.id}"`,
          maxResultCount: 500,
          skipCount: 0
        }
      })
      this.$Spin.hide()
      if (!rep.data.success || rep.data.result.items.length === 0) {
        this.$Message.info('请先编制包组')
        return
      }
      // 检查挂网信息填完
      let projectData = this.projectData
      if ((projectData.netPerson && projectData.netTime && projectData.entryFee && projectData.applyEnd && this.operatorInfo.spreadWeb.length>0 && projectData.onlineApply) || this.hasSubmit) {
        this.selectArticle = {
          id: '',
          articleContentId: '',
          title: '',
          articleContent: '',
          fileDispaly: false,
          endTimeDispaly: false,
          isGroupCalc: false,
          isDispaly: true,
        }
        this.articleEditorVisible = true
        return
      }
      this.$Message.error('请先填完挂网信息')
    },
    async articleAddSuccess() {
      this.articleEditorVisible = false
      this.$emit('refreshArticles')
      // 挂网成功修改项目状态
      if (this.projectData.projectState === '审查通过可挂网') {
        let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
          id: this.projectData.id,
          projectState: '已挂网文件售卖中'
        })
      }
    },
    submitOperateInfo() {
      this.$refs.operatorInfo.validate(async (valid) => {
        if (valid) {
          if (!this.operatorInfo.inviteDate) {
            this.$Message.error('请输入挂网日期')
            return
          }
          if (!this.operatorInfo.enrollEndDate) {
            this.$Message.error('请输入截止日期')
            return
          }
          if (this.operatorInfo.enrollFee > 9999) {
            this.$Message.error('报名费不得超过9999元，请重新输入')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateNet, {
              id: this.projectData.id,
              netPerson: this.operatorInfo.operator,
              netTime: formatDate(this.operatorInfo.inviteDate),
              entryFee: this.operatorInfo.enrollFee,
              applyEnd: formatDate(this.operatorInfo.enrollEndDate),
              net: this.operatorInfo.spreadWeb[0],
              net2: this.operatorInfo.spreadWeb[1],
              net3: this.operatorInfo.spreadWeb[2],
              net4: this.operatorInfo.spreadWeb[3],
              onlineApply: this.operatorInfo.isWebEnroll,
              merchandiser: this.operatorInfo.merchandiser,
              agencyContactNumber: this.operatorInfo.agencyContactNumber,
              agencyContactPerson: this.operatorInfo.agencyContactPerson,
              isGroupPrice: this.operatorInfo.isGroupPrice
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('招标挂网信息提交成功')
              this.hasSubmit = true

              // 如果修改报名费和报名截止日期
              if (this.articles.length > 0) {
                let promises = []
                this.articles.forEach(article => {
                  article.endTime = formatDate(this.operatorInfo.enrollEndDate)
                  article.amount = this.operatorInfo.enrollFee
                  article.isApply = false
                  if (this.operatorInfo.isWebEnroll === "是") {
                    article.isApply = true
                  }
                  let promise = ajax.post(requestUrls.articles.CreateOrUpdate, {
                    abpArticles: article
                  })
                  promises.push(promise)
                })
                let results = await Promise.all(promises)
              }


            } else {
              this.$Message.error('招标挂网信息提交失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('招标挂网信息提交失败')
          }
        }
      })
    },
    // 选择文件
    handleBeforeUpload(file) {
			// 初始化文件上传
      fileUtil.downloadInit(this.user.id,2,this.bucket,this.dir).then(val => {
        this.uploadFileInit = val
      })
      this.operatorInfo.bidFile = file
      this.$set(this.operatorInfo.bidFile, 'displayName', file.name)
			setTimeout(() => {
				this.upLoad()
			},500)
      return false
    },
    // 上传文件
    async upLoad() {
			let suffix = fileUtil.get_suffix(this.operatorInfo.bidFile.name)
			this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
			this.uploadFileInit.extradata['x:displayname'] = this.operatorInfo.bidFile.name
			this.uploadFileInit.extradata['x:objectid'] = this.projectData.id
			this.uploadFileInit.extradata['x:objectidtype'] = 'enroll'
			this.$Spin.show()
			try {
				let uploadData = new FormData()
				for (let key in this.uploadFileInit.extradata) {
					uploadData.append(key, this.uploadFileInit.extradata[key])
				}
				uploadData.append('file', this.operatorInfo.bidFile)
				let rep = await axios.post(this.uploadFileInit.action, uploadData)
				this.$Spin.hide()
				if (rep.data.success) {
					this.$Message.success(`上传成功`)
				} else {
          this.operatorInfo.bidFile = ''
					this.$Message.error(`上传失败`)
				}
			} catch (err) {
				console.error(err)
        this.$Spin.hide()
        this.operatorInfo.bidFile = ''
				this.$Message.error(`上传失败`)
			}
			this.getHistory(this.projectData.id)
			return
    },
    getHistory(id) {
      ajax.get(requestUrls.AbpAliOss.GetListByObjectId,{
        params: {
          objectId: id,
          objectIdType: 'enroll'
        }
      }).then(res => {
        let arr = res.data.result.items.filter(item => item.fileType == '2')
        if (arr.length > 0) this.operatorInfo.bidFile = arr[arr.length - 1]
      })
    },
    async downloadFile () {
      // let rep = await ajax.get(requestUrls.AbpAliOss.GetDownUrl, {
      //   params: {
      //     id: this.operatorInfo.bidFile.id
      //   }
      // })
      const { fileName, bucket } = this.operatorInfo.bidFile
      let rep = await localFile.getPermanentDownUrl(bucket, fileName)
      console.log(rep)
      window.open(rep)
    },
    delectFile() {
      this.$Modal.confirm({
        title: '文件删除',
        okText: '删除',
        cancelText: '取消',
        content: `确定要删除采购文件电子版吗?`,
        onOk: () => {
          ajax.delete(requestUrls.AbpAliOss.Delete, {
            params: {
              id: this.operatorInfo.bidFile.id
            }
          }).then(() => {
            this.$Message.success('删除成功')
            this.operatorInfo.bidFile = ''
          })
        },
        onCancel: () => {}
      })
    },
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
  },
  watch: {
    projectData(val) {
      if (val) {
        this.hasSubmit = false
        this.operatorInfo.bidFile = ''
        this.operatorInfo.operator = val.netPerson
        this.operatorInfo.inviteDate = ''
        if (val.netTime) {
          this.operatorInfo.inviteDate = val.netTime.replace('T', ' ')
        }
        this.operatorInfo.enrollFee = val.entryFee
        if (val.entryFee) {
          this.operatorInfo.enrollFee = val.entryFee.toString()
        }
        if (val.applyEnd) {
          this.operatorInfo.enrollEndDate = val.applyEnd.replace('T', ' ')
        }
        this.operatorInfo.isWebEnroll = val.onlineApply
        this.operatorInfo.isGroupPrice = val.isGroupPrice
        this.operatorInfo.spreadWeb = []
        if (val.net) {
          this.operatorInfo.spreadWeb.push(val.net)
        }
        if (val.net2) {
          this.operatorInfo.spreadWeb.push(val.net2)
        }
        if (val.net3) {
          this.operatorInfo.spreadWeb.push(val.net3)
        }
        if (val.net4) {
          this.operatorInfo.spreadWeb.push(val.net4)
        }
        if (this.operatorInfo.spreadWeb.length === 0) {
          this.operatorInfo.spreadWeb.push('采联国际')
        }
        this.operatorInfo.merchandiser = val.merchandiser
        this.operatorInfo.agencyContactNumber = val.agencyContactNumber
        this.operatorInfo.agencyContactPerson = val.agencyContactPerson
        this.getHistory(val.id)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.invite-modal {
  .ivu-modal {
    top: 50px;
  }
}
.ivu-select-dropdown {
  top: 33px !important;
}
</style>
